import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { t } from "i18next";
import React from "react";
import CommonButton from "../../common/Button";
import { SuccessInputProps } from "../../../interfaces/CategoryTransactionInterface";


const SuccessInput = (props: SuccessInputProps) => {
    const { transactionItem, index, accordionButtonStates, activeAccordionIndex, accordionPayloadData, productCategoryMapping, isFind, setAccordionPayloadData } = props;

    /**
         * 
         * @param event - The event object from the input change.
         * @param fieldType - The type of field being changed (from or to).
         * @returns void
         * @description Handles the change event for category code in the success transaction list.
         */
    const successCategoryChangeHandler = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        fieldType: "from" | "to"
    ) => {
        const newCategoryCode = event.target.value;
        const accordionIndex = activeAccordionIndex;
        if (accordionIndex === null) return;

        setAccordionPayloadData(prev => {
            const updatedData = [...(prev[accordionIndex] || [])];
            const fieldIndex = fieldType === "from" ? 0 : 1;

            updatedData[fieldIndex] = {
                ...updatedData[fieldIndex],
                categoryCode: newCategoryCode
            };

            return {
                ...prev,
                [accordionIndex]: updatedData
            };
        });
    };

    /**
         * 
         * @param event - The event object from the input change.
         * @param fieldType - The type of field being changed (from or to).
         * @returns void
         * @description Handles the change event for publishStatus in the success transaction list.
         */
    const successPublishStatusChangeHandler = (
        event: SelectChangeEvent<unknown>,
        fieldType: "from" | "to"
    ) => {
        const newStatus = event.target.value as number;
        const accordionIndex = activeAccordionIndex;
        if (accordionIndex === null) return;
    
        setAccordionPayloadData(prev => {
            const updatedData = [...(prev[accordionIndex] || [])];
            const fieldIndex = fieldType === "from" ? 0 : 1;
    
            updatedData[fieldIndex] = {
                ...updatedData[fieldIndex],
                publishStatus: newStatus
            };
    
            return {
                ...prev,
                [accordionIndex]: updatedData
            };
        });
    };

    return (
        <Grid sx={{ backgroundColor: transactionItem.adminActions?.length > 0 ? "#dafff5" : "#f4f4f4", padding: 2 }} mx={isFind ? -2 : 0} mt={isFind && transactionItem.successCategory?.length === 0 && transactionItem?.adminActions?.length === 0 && transactionItem.failedCategory?.length === 0 ? -1 : 0}>            
            <Grid container spacing={1} mt={1}>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                    <TextField
                        label={t("category_management.category_code")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={accordionPayloadData[activeAccordionIndex]?.[0]?.categoryCode??""}
                        onChange={(event) => successCategoryChangeHandler(event, "from")}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label" sx={{backgroundColor: transactionItem.adminActions?.length > 0 ? "#dafff5" : "#f4f4f4" }} >{t("category_management.publication_status")}</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            fullWidth
                            onChange={(event) => successPublishStatusChangeHandler(event, "from")}
                            value={accordionPayloadData[activeAccordionIndex]?.[0]?.publishStatus ?? 9}
                        >
                            <MenuItem value={0}>0</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={1} mt={2}>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                    <TextField
                        label={t("category_management.category_code")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={accordionPayloadData[activeAccordionIndex]?.[1]?.categoryCode??""}
                        onChange={(event) => successCategoryChangeHandler(event, "to")}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label" sx={{backgroundColor: transactionItem.adminActions?.length > 0 ?"#dafff5" :"#f4f4f4" }} >{t("category_management.publication_status")}</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            fullWidth
                            onChange={(event) => successPublishStatusChangeHandler(event, "to")}
                            value={accordionPayloadData[activeAccordionIndex]?.[1]?.publishStatus}
                        >
                            <MenuItem value={0}>0</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid mt={1}>
                <CommonButton
                    sx={{ height: 40 }}
                    functionToExecute={() => productCategoryMapping(transactionItem?.cainzProductCode, index)}
                    className=""
                    btnName={t("category_management.execute")}
                    disableCondition={
                        activeAccordionIndex !== index ||
                        accordionButtonStates[index] ||
                        !accordionPayloadData[index]?.length
                    }
                />
            </Grid>
        </Grid>
    );
};

export default SuccessInput;